import {
    LOAD_CONFIG,
  } from '../types';
  
  export function initConfig() {
    return {
      type: LOAD_CONFIG
    };
  }
  